import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { eventService } from "./eventsService";

// Thunks
export const getAllEvents = createAsyncThunk("events/get", async (_, thunkAPI) => {
  try {
    return await eventService.getEvents();
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const getAnEvent = createAsyncThunk("event/get", async (id, thunkAPI) => {
  try {
    return await eventService.getEvent(id);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

// Initial State
const eventState = {
  events: [],
  eventData: {},
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

// Slice
export const eventSlice = createSlice({
  name: "events",
  initialState: eventState,
  reducers: {
    resetState: () => eventState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllEvents.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllEvents.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.events = action.payload;
      })
      .addCase(getAllEvents.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getAnEvent.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAnEvent.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.singleEvent = action.payload;
      })
      .addCase(getAnEvent.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { resetState } = eventSlice.actions;
export default eventSlice.reducer;
